import { taskContentView, type TaskContentView } from './task-content-view';

type Source = Parameters<typeof taskContentView>[0];

export const SOCIAL_POST_TASK_POLL_MS = 5_000;
export const SOCIAL_POST_TASK_POLL_FOR_MS = 10 * 60_000;

export function socialPostTaskView(task: Source, now: number): TaskContentView | undefined {
  const view = taskContentView(task, now, { publishTime: true });
  return view?.kind === 'social' && (view.state === 'scheduled' || view.state === 'done' || view.state === 'working') ? view : undefined;
}

export const SOCIAL_POST_GONE_OUT_MARGIN_MS = 2 * 60_000;
const MAX_TIMER_MS = 2_147_483_647;

export function socialPostTaskPollMs(task: Source | undefined, now: number, since: number): number | false {
  if (!task) return false;
  if (task.status === 'COMPLETED' || task.status === 'CANCELLED' || task.status === 'MOOT' || task.status === 'FAILED') return false;
  const view = taskContentView(task, now, { publishTime: true });
  if (view?.state === 'done') return false;
  if (view?.state === 'scheduled') {
    const goesOut = Date.parse(view.scheduledAt ?? '');
    if (!Number.isFinite(goesOut)) return false;
    const wait = goesOut + SOCIAL_POST_GONE_OUT_MARGIN_MS - now;
    return wait > 0 ? Math.min(Math.max(wait, SOCIAL_POST_TASK_POLL_MS), MAX_TIMER_MS) : false;
  }
  return now - since > SOCIAL_POST_TASK_POLL_FOR_MS ? false : SOCIAL_POST_TASK_POLL_MS;
}
